/* eslint-disable jsx-a11y/label-has-associated-control */
// import Gantt from "components/gantt-layout/gantt";

// function ProcurementSchedule() {
//   return (
//     <div>
//       <Gantt />
//     </div>
//   );
// }

// export default ProcurementSchedule;

import { useEffect, useState } from "react";
// import Gantt from "components/gantt-layout/Gantt/index";
import Toolbar from "components/gantt-layout/Toolbar/index";
import "components/gantt-layout/style.scss";
// import SidePanel from "components/gantt-layout/SidePanel/SidePanel";
// import { getData } from "./data.js";
// import {
//   DateUtils,
//   DATE_FORMAT_MMDDYYYY,
//   DATE_FORMAT_YYYYMMDD
// } from "utils/dateutils";
// import Separator from "components/date-range-picker/separator";
import SubmittalMaterialView from "components/gantt-layout/submittal-material-view";
import ActivityView from "components/gantt-layout/activity-view";
import { useParams } from "react-router";
import { aData } from "./activityData";

// const { RangePicker } = DatePicker;
interface SubTask {
  id: string;
  text: string;
  name_milestone: string;
  start_date: string | null;
  end_date: string | null;
  parent: string;
  type: string;
  risk_level: string;
  risk_assessment: string;
  current_step?: boolean;
  hoverText: {
    text: string;
    start_date: string | null;
    end_date: string | null;
    risk_level: string;
    risk_assessment: string;
  };
}
interface Task {
  risk_assessment?: any;
  id: string;
  text: string;
  start_date: string | null;
  end_date?: string | null;
  parent?: string;
  type?: string;
  risk_level?: string;
  activity_count?: number;
  open?: boolean;
  render?: string;
  milestones?: SubTask[];
}

interface Link {
  id: string;
  source: string;
  target: string;
  type: any;
}

interface GanttData {
  data: Task[];
  links: Link[];
}

interface ResponseObject {
  vendors: Task[];
  submittals: Task[];
  materials: Task[];
  links: Link[];
}

export const formatDate = (date: string | null | undefined): string | null => {
  if (date !== null && date !== undefined) {
    const formattedDate = new Date(date!);
    return `${String(formattedDate.getDate()).padStart(2, "0")}-${String(
      formattedDate.getMonth() + 1
    ).padStart(2, "0")}-${formattedDate.getFullYear()}`;
  }
  return null;
};

function ProcurementSchedule() {
  const { projectId } = useParams() as any;
  const [zoomSelection, setZoomSelection] = useState<string>("Quarter");
  const [viewSelection, setViewSelection] = useState<string>("1");
  const [ganttTasks, setTasks] = useState<GanttData>({ data: [], links: [] });
  const [activityData, setActivityData] = useState<any>({
    data: [],
    links: []
  });
  const [isOpen] = useState<boolean>(false);
  // const [dateRange, setDateRange] = useState<any>();

  const togglePanel = (): void => {
    // setIsOpen(!isOpen);
  };

  const createGanttData = (respObj: ResponseObject): void => {
    const data: Task[] = [];
    // let index: number = 0;
    const uniqueIds = new Set<string>();

    const { vendors } = respObj;
    const submittals = respObj.submittals.sort((a, b) =>
      a.text.localeCompare(b.text)
    );
    const materials = respObj.materials.sort((a, b) =>
      a.text.localeCompare(b.text)
    );
    const { links } = respObj;

    const childMap = new Map<string, string[]>();
    links.forEach((link) => {
      const sourceId = link.source;
      const targetId = link.target;

      if (!childMap.has(sourceId)) {
        childMap.set(sourceId, []);
      }
      childMap.get(sourceId)!.push(targetId);
    });

    vendors.forEach((vendor) => {
      let leastStartDate = new Date("9999-12-31");

      const vendorSubmittals = submittals.filter(
        (submittal) => submittal.parent === vendor.id
      );

      vendorSubmittals.forEach((submittal) => {
        const submittalStartDate = new Date(submittal.start_date!);
        if (submittal.start_date && submittalStartDate < leastStartDate) {
          leastStartDate = submittalStartDate;
        }

        if (!uniqueIds.has(submittal.id)) {
          uniqueIds.add(submittal.id);
          const submittalNode: Task = {
            id: submittal.id,
            text: submittal.text,
            start_date: formatDate(submittal.start_date),
            end_date: formatDate(submittal.end_date),
            parent: vendor.id,
            type: submittal.type,
            risk_level: submittal.risk_level,
            risk_assessment: submittal.risk_assessment,
            render: "split",
            open: false
          };
          data.push(submittalNode);

          // submittal.milestones?.forEach((milestone) => {
          //   const milestoneNode: SubTask = {
          //     id: (index + 1).toString(),
          //     text: milestone.name_milestone,
          //     start_date: formatDate(milestone.start_date),
          //     end_date: formatDate(milestone.end_date),
          //     parent: milestone.parent,
          //     type: milestone.type,
          //     risk_level:
          //       submittalNode.risk_level && milestone.current_step
          //         ? submittalNode.risk_level
          //         : "",
          //     risk_assessment: milestone.current_step
          //       ? submittalNode.risk_assessment
          //       : "",
          //     ...(milestone.current_step ? { rollUp: true } : null),
          //     name_milestone: milestone.name_milestone,
          //     hoverText: {
          //       text: submittalNode.text ?? "",
          //       start_date: submittalNode.start_date,
          //       end_date: submittalNode.end_date ?? null,
          //       risk_level: submittalNode.risk_level ?? "",
          //       risk_assessment: submittalNode.risk_assessment
          //     }
          //   };
          //   index += 1;
          //   data.push(milestoneNode);
          // });
        }

        const linkedMaterialIds = childMap.get(submittal.id) || [];
        linkedMaterialIds.forEach((materialId) => {
          const material = materials.find((mat) => mat.id === materialId);

          const materialStartDate = new Date(material?.start_date!);
          if (material?.start_date && materialStartDate < leastStartDate) {
            leastStartDate = materialStartDate;
          }

          if (material && !uniqueIds.has(material.id)) {
            uniqueIds.add(material.id);
            const materialNode: Task = {
              id: material.id,
              text: material.text,
              start_date: formatDate(material.start_date),
              end_date: formatDate(material.end_date),
              parent: vendor.id,
              type: material.type,
              risk_level: material.risk_level,
              risk_assessment: submittal.risk_assessment,
              activity_count: material.activity_count,
              render: "split",
              open: false
            };
            data.push(materialNode);

            // const len: number | undefined = material.milestones?.length;
            // material.milestones?.forEach((milestone, count) => {
            //   const milestoneNode: SubTask = {
            //     id: (index + 1).toString(),
            //     text: milestone.name_milestone,
            //     start_date: formatDate(milestone.start_date),
            //     end_date: formatDate(milestone.end_date),
            //     parent: milestone.parent,
            //     type: milestone.type,
            //     risk_level:
            //       materialNode.risk_level && milestone.current_step
            //         ? materialNode.risk_level
            //         : "",
            //     risk_assessment: milestone.current_step
            //       ? material.risk_assessment
            //       : "NONE",
            //     ...(milestone.current_step ? { rollUp: true } : null),
            //     ...(len !== undefined && len > 0 && count === len - 1
            //       ? {
            //           lastMilestone: true,
            //           activity_count: material.activity_count
            //         }
            //       : null),
            //     name_milestone: milestone.name_milestone,
            //     hoverText: {
            //       text: materialNode.text ?? "",
            //       start_date: materialNode.start_date,
            //       end_date: materialNode.end_date ?? null,
            //       risk_level: materialNode.risk_level ?? "",
            //       risk_assessment: materialNode.risk_assessment
            //     }
            //   };
            //   index += 1;
            //   data.push(milestoneNode);
            // });
          }
        });
      });

      const vendorStartDate =
        leastStartDate < new Date("9999-12-31")
          ? formatDate(leastStartDate.toISOString())
          : null;
      const vendorNode: Task = {
        id: vendor.id,
        text: vendor.text,
        start_date: vendorStartDate,
        type: vendor.type,
        risk_level: ""
      };
      data.push(vendorNode);
    });

    const tasks: GanttData = {
      data,
      links: respObj.links
    };
    setTasks(tasks);
  };

  useEffect(() => {
    // const url = window.location.href;
    // const projectId = url.split("project/")[1].split("/")[0];
    // fetch(`http://54.227.202.17:4000/procurement-schedule/${projectId}`)
    fetch(
      `https://proc-schedule.constructiviq.com/procurement-schedule/${projectId}`
    )
      .then((response) => response.json())
      .then((data: ResponseObject) => createGanttData(data))
      .catch((error) => console.error("Error fetching data:", error));
  }, [projectId]);

  useEffect(() => {
    if (viewSelection === "2") {
      const actData = {
        data: aData.data.map((task) => ({
          id: task.id,
          text: task.text,
          start_date: formatDate(task.start_date),
          end_date: formatDate(task.end_date),
          parent: task.parent,
          type: task.type === 0 ? "V" : "A"
        })),
        links: aData.links.map((link) => ({
          id: link.id,
          source: link.source,
          target: link.target,
          type: link.gantt_link_type.id.toString()
        }))
      };
      setActivityData(actData);
    }
  }, [viewSelection]);

  return (
    <div>
      <div className="zoom-bar">
        <Toolbar
          setZoomSelection={setZoomSelection}
          setViewSelection={setViewSelection}
        />
        {/* <div style={{ paddingLeft: "20px" }}>
          <label style={{ paddingRight: "10px" }}>Risk Level:</label>
          <Checkbox className="filterCheckbox" name="HIGH">
            High
          </Checkbox>
          <Checkbox className="filterCheckbox" name="MEDIUM">
            Medium
          </Checkbox>
          <Checkbox className="filterCheckbox" name="LOW">
            Low
          </Checkbox>
        </div> */}
        {/* <div style={{ paddingLeft: "20px", display: "flex" }}>
          <label style={{ width: "120px" }}>Date Range:</label>
          <RangePicker
            separator={Separator()}
            className="w-full"
            format={DATE_FORMAT_MMDDYYYY}
            value={dateRange}
            onChange={(dates: any) => {
              setDateRange(dates);
            }}
            placement="bottomLeft"
            bordered
          />
        </div> */}
      </div>

      {ganttTasks.data.length > 0 && viewSelection === "1" && (
        <SubmittalMaterialView
          task={ganttTasks}
          zoomSelection={zoomSelection}
          togglePanel={togglePanel}
          isOpen={isOpen}
        />
      )}
      {activityData.data.length > 0 && viewSelection === "2" && (
        <ActivityView
          task={activityData}
          zoomSelection={zoomSelection}
          togglePanel={togglePanel}
          isOpen={isOpen}
        />
      )}
    </div>
  );
}

export default ProcurementSchedule;
